import './style.scss';
/* eslint-disable no-param-reassign */
import React, { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Popconfirm } from 'antd';
import {
  CloseOutlined,
} from '@ant-design/icons';
import H3FormInput from '@Uilib/h3FormInput';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { QUANTITY } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import ProductCategoryLabel from '@Components/Common/ProductCategoryLabel';
import RawMaterialBatchSelector from '../../../../ManufacturingOrders/ViewManufacturingOrder/Drawer/UpdateRawMaterial/RawMaterialBatchSelector';
import HideValue from '../../../../../Common/RestrictedAccess/HideValue';

const RawMaterial = ({
  data, handleToggleBatch, loading, trackWastage, handleProductChangeValue, handleProductChange, formSubmitted, addNewRow, tenantDepartmentId, excludedProducts, updateData, createMOLoading, updateMOLoading, handleQuantityChange, multipleFG, MONEY, handleDelete, updateRmBatchConsumptionMethod, allStock, updateAllStock, updateBatchValue, user, priceMasking,
}) => {
  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
  const getColumns = (isChild) => {
    const columns = [
      {
        title: 'Product',
        width: '240px',
        render: (text, record) => {
          return (
            <div className="mo-rw-table__product-name">
              {record?.bomLineId || record?.mo_line_id ? (
                <React.Fragment>
                  <Link to={`/inventory/product/view/${record?.tenant_product_info?.product_sku_id}`} target="_blank">
                    {`#${record?.tenant_product_info?.internal_sku_code}`}
                  </Link>
                  <div>
                    {`${record?.tenant_product_info?.ref_product_code ? `${record?.tenant_product_info?.ref_product_code} - ` : ''}${record?.productSkuName}`?.trim()}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <ProductFilterV2
                    record={record}
                    productTypes={['STORABLE', 'SERVICE', 'NON_STORABLE']}
                    handleProductChangeValue={handleProductChangeValue}
                    handleProductChange={handleProductChange}
                    required
                    showError={formSubmitted && !record.productSkuName}
                    onClear={(key) => {
                      const copyData = JSON.parse(JSON.stringify(data));
                      const newData = copyData.map((item) => {
                        if (item.key === key) {
                          return {
                            key: uuidv4(),
                            asset1: '',
                            productSkuName: '',
                            product_sku_id: null,
                            product_sku_info: null,
                            quantity: '',
                            unitPrice: '',
                            taxId: '',
                            lot: '',
                          };
                        }
                        return {
                          ...item,
                        };
                      });
                      addNewRow();
                      updateData(newData);
                    }}
                    excludedProducts={excludedProducts}
                    tenantDepartmentId={tenantDepartmentId}
                    disabled={record?.product_sku_id}
                    showClear={!!record?.product_sku_id}
                  />
                </React.Fragment>
              )}
              {record?.product_category_info?.category_path?.length > 0 && (
                <ProductCategoryLabel
                  categoryPath={record?.product_category_info?.category_path}
                  categoryName={record?.product_category_info?.category_path?.at(-1)}
                  containerStyle={{
                    width: 'fit-content',
                  }}
                />
              )}
            </div>
          );
        },
      },
      {
        title: 'Current Stock',
        width: '120px',
        dataIndex: 'quantity',
        render: (text, record) => <Fragment>
          <div>
            {
              `${QUANTITY(
                ((Helpers.getValueTotalInObject(record?.product_batches?.filter((i) => i?.batch_in_use && (record?.good_stock_only ? !i?.is_rejected_batch : true)), 'available_qty') * record?.product_info?.uom_info?.ratio) / record?.uomInfo?.ratio) || '0',
                record?.uomInfo?.precision,
              )} ${record?.uomInfo?.uqc?.toProperCase() || ''}`
            }
          </div>
          <div className="table-subscript">{`in ${record?.product_batches?.filter((i) => i?.batch_in_use)?.length} Batches`}</div>
        </Fragment>,
      },
      {
        title: 'Estimated Usage',
        width: '120px',
        dataIndex: 'quantity',
        render: (text, record) => `${QUANTITY(record?.originalEstimatedUsage, record?.uomInfo?.precision)} ${record?.uomInfo?.uqc?.toProperCase() || ''}`,
      },
      {
        title: 'Actual Usage',
        width: '173px',
        render: (text, record) => {
          const currentStock = ((record?.currentStock * record?.product_info?.uom_info?.ratio) / record?.uomInfo?.ratio);
          return multipleFG ? (
            <div style={{ marginLeft: '5px' }}>
              {`${QUANTITY(record.estimatedUsage, record?.tenant_product_info?.uom_info?.precision)} ${record?.tenant_product_info?.uom_info?.uqc?.toProperCase()}`}
            </div>
          ) : (
            <React.Fragment>
              <div className="mo-rm-table__quantity">
                {isChild ? QUANTITY(record?.estimatedUsage, record?.tenant_product_info?.uom_info?.precision) : (
                  <H3FormInput
                    name="a valid quantity"
                    type="number"
                    containerClassName="mo-form__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) => {
                      handleQuantityChange(record?.fg_tenant_product_id, e.target.value, record?.key, record?.wastage_quantity);
                    }}
                    value={record?.estimatedUsage}
                    showError={formSubmitted && (!record?.estimatedUsage || Number(record?.estimatedUsage) === 0)}
                    disabled={createMOLoading || updateMOLoading}
                    loading={createMOLoading || updateMOLoading}
                  />
                )}
                <H3Text text={record?.tenant_product_info?.uom_info?.uqc?.toProperCase()} className="mo-rm-table__quantity-unit" />
              </div>
              {(record?.estimatedUsage + record?.wastage_quantity) > Helpers.getValueTotalInObject(record?.product_batches?.filter((i) => i?.batch_in_use), 'available_qty') && <span className="input-error">*Stock not available</span>}
            </React.Fragment>
          );
        },
      },
    ];
    if (trackWastage) {
      columns.push({
        title: 'Wastage',
        width: '173px',
        render: (text, record) => {
          return multipleFG ? (
            <div style={{ marginLeft: '5px' }}>
              {`${QUANTITY(record.wastage_quantity, record?.tenant_product_info?.uom_info?.precision)} ${record?.tenant_product_info?.uom_info?.uqc?.toProperCase()}`}
            </div>
          ) : (
            <div>
              <div className="mo-rm-table__quantity">
                {isChild ? QUANTITY(record?.wastage_quantity || 0, record?.tenant_product_info?.uom_info?.precision) : (
                  <H3FormInput
                    name="a valid quantity"
                    type="number"
                    containerClassName="mo-form__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) => {
                      handleQuantityChange(record?.fg_tenant_product_id, record?.estimatedUsage, record?.key, e.target.value);
                    }}
                    value={record?.wastage_quantity}
                    showError={formSubmitted && Number(record?.wastage_quantity) < 0}
                    disabled={createMOLoading || updateMOLoading}
                    loading={createMOLoading || updateMOLoading}
                  />
                )}
                <H3Text text={record?.tenant_product_info?.uom_info?.uqc?.toProperCase()} className="mo-rm-table__quantity-unit" />
              </div>
              <div className="table-subscript"  >
                {`${record?.wastage_percentage || '0'}% as per Bill of Material`}
              </div>
            </div>
          );
        },
      });
    }
    columns.push(
      {
        title: 'Unit Cost',
        width: '140px',
        render: (text, record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view unit cost"} /> : `${MONEY(record?.costPerUnit || 0)}`),
      },
      {
        title: 'Estimated Cost',
        render: (text, record) => ((isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view unit cost"} /> : `${MONEY((record?.costPerUnit * (record.estimatedUsage + (trackWastage ? Number(record?.wastage_quantity) : 0))) || '0')}`),
      },
      {
        title: 'Incurred Cost',
        render: (text, record) => {
          const batches = record?.product_batches;
          let incurredCost = 0;
          for (let i = 0; i < batches?.length; i++) {
            if (batches[i]?.consumed_qty > 0) {
              incurredCost += (batches[i]?.landed_cost * (trackWastage ? (Number(record?.estimatedUsage) + Number(record?.wastage_quantity)) : Number(record?.estimatedUsage)));
            }
          }
          return (isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view unit cost"} /> : MONEY(incurredCost || '0');
        },
      },
      {
        title: ' ',
        width: '40px',
        render: (text, record) => {
          return (
            <Popconfirm
              title="Confirm remove Raw material?"
              onConfirm={() => handleDelete(record?.product_sku_id, record?.key)}
              onCancel={() => { }}
              okText="Yes"
              cancelText="No"
              placement="topLeft"
            >
              <div className="mp-fg__delete-line-button">
                <CloseOutlined />
              </div>
            </Popconfirm>
          );
        },
      },
    );

    return columns;
  };

  const getDataSource = () => {
    if (data) {
      return JSON.parse(JSON.stringify(data));
    }
    return [];
  };

  return (
    <React.Fragment>
      <div className="mo-rw-table-wrapper hide__in-mobile">
        <Table
          bordered
          loading={loading}
          showHeader
          size="small"
          scroll={{ x: true }}
          columns={getColumns(false)}
          dataSource={getDataSource()}
          pagination={false}
          expandable={{
            rowExpandable: (record) => record?.tenant_product_info?.product_batches?.map((item) => item.product_batches > 0)?.length,
            expandedRowRender: (record) => (
              <div style={{ padding: '0px 8px 0px 12px' }}>
                <RawMaterialBatchSelector
                  batchMethod={record?.batchConsumptionMethod}
                  updateBatchConsumptionMethod={(value) => {
                    updateRmBatchConsumptionMethod(record?.fg_tenant_product_id, value, record?.key);
                  }}
                  batches={record?.good_stock_only ? record?.product_batches.filter((item) => !item.is_rejected_batch) : record?.product_batches}
                  uomInfo={record?.uom_info}
                  expiryDays={record?.product_info?.expiry_days}
                  itemsRow={record}
                  onToggleBatch={(batch, productBatchesRow) => handleToggleBatch(batch, productBatchesRow, record?.fg_tenant_product_id)}
                  allStock={record?.good_stock_only}
                  updateAllStock={(value) => updateAllStock(value, record?.fg_tenant_product_id, record?.key)}
                  updateBatchValue={(value, label, batchId) => updateBatchValue(record?.key, value, label, batchId, record?.fg_tenant_product_id)}
                  hideSelectAllBatchesOption
                />
              </div>
            ),
          }}
        />
      </div>
    </React.Fragment>
  );
};

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
  priceMasking: UserReducers.priceMasking,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = () => ({

});

RawMaterial.propTypes = {
  loading: PropTypes.bool,
  handleProductChangeValue: PropTypes.func,
  handleProductChange: PropTypes.func,
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  data: PropTypes.any,
  formSubmitted: PropTypes.bool,
  addNewRow: PropTypes.func,
  createMOLoading: PropTypes.bool,
  updateMOLoading: PropTypes.bool,
  multipleFG: PropTypes.bool,
  handleQuantityChange: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RawMaterial));
